import { useRoute } from '#imports'
import { ref, watch } from 'vue'

export function useToggleFilters() {
  const filterByCurrentSeller = ref(false)
  const filterByPictures = ref(false)
  const filterByCountry = ref(false)

  const route = useRoute()

  watch(
    () => route.query,
    () => {
      const {
        seller_public_id: merchantId,
        with_attachments: withAttachments,
        locale,
      } = route.query

      filterByCurrentSeller.value = !!merchantId
      filterByPictures.value = !!withAttachments
      filterByCountry.value = !!locale
    },
    { immediate: true },
  )

  return {
    filterByCurrentSeller,
    filterByPictures,
    filterByCountry,
  }
}
